module.exports = __webpack_public_path__ + "img/seeds.e8f8cd8f.jpg";